import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'stripHtml',
  standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
  constructor(private readonly _sanitizer: DomSanitizer) {}

  public transform(value: string): string {
    if (!value) {
      return '';
    }

    // Sanitize the input to remove unsafe content
    const sanitizedValue = this._sanitizer.sanitize(SecurityContext.HTML, value);
    if (!sanitizedValue) {
      return '';
    }

    // Create a temporary DOM element to strip all HTML tags
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sanitizedValue;

    // Extract and return plain text content
    return tempDiv.textContent?.trim() || tempDiv.innerText.trim() || '';
  }
}
